// Single source of truth for lead-source connectors, used by the setup wizard
// and the Settings → Sources catalog.

export type AuthType = 'cookies' | 'phone' | 'subreddits' | 'queries' | 'none';

export interface Connector {
  id: string;
  name: string;
  status: 'live' | 'soon';
  authType: AuthType;
  blurb: string;
  emoji: string;
}

export const CONNECTORS: Connector[] = [
  // ── Live ──
  { id: 'facebook', name: 'Facebook', status: 'live', authType: 'cookies', blurb: 'Groups & marketplace', emoji: '🔵' },
  { id: 'telegram', name: 'Telegram', status: 'live', authType: 'phone', blurb: 'Channels & groups', emoji: '✈️' },
  { id: 'reddit', name: 'Reddit', status: 'live', authType: 'subreddits', blurb: 'Subreddit communities', emoji: '🟠' },
  { id: 'youtube', name: 'YouTube', status: 'live', authType: 'queries', blurb: 'Video comments', emoji: '▶️' },
  // ── Coming soon (request access) ──
  { id: 'instagram', name: 'Instagram', status: 'soon', authType: 'none', blurb: 'Hashtags & comments', emoji: '📸' },
  { id: 'twitter', name: 'X / Twitter', status: 'soon', authType: 'none', blurb: 'Real-time intent posts', emoji: '𝕏' },
  { id: 'linkedin', name: 'LinkedIn', status: 'soon', authType: 'none', blurb: 'Professional network', emoji: '💼' },
  { id: 'whatsapp', name: 'WhatsApp', status: 'soon', authType: 'none', blurb: 'Community groups', emoji: '🟢' },
  { id: 'discord', name: 'Discord', status: 'soon', authType: 'none', blurb: 'Servers & channels', emoji: '🎮' },
  { id: 'quora', name: 'Quora', status: 'soon', authType: 'none', blurb: 'Questions & answers', emoji: '❓' },
  { id: 'tiktok', name: 'TikTok', status: 'soon', authType: 'none', blurb: 'Comments & trends', emoji: '🎵' },
  { id: 'nextdoor', name: 'Nextdoor', status: 'soon', authType: 'none', blurb: 'Neighborhood posts', emoji: '🏡' },
  { id: 'dubizzle', name: 'Dubizzle / OLX', status: 'soon', authType: 'none', blurb: 'Classifieds', emoji: '🏷️' },
  { id: 'google_business', name: 'Google Business', status: 'soon', authType: 'none', blurb: 'Reviews & questions', emoji: '🌐' },
];

export const CONNECTOR_BY_ID: Record<string, Connector> =
  Object.fromEntries(CONNECTORS.map((c) => [c.id, c]));

export const LIVE_IDS = CONNECTORS.filter((c) => c.status === 'live').map((c) => c.id);
